import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, createVNode as _createVNode, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "app-notify__content" }

import { computed, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    show: {
        type: Boolean,
        default: false
    },
    // 展示时长(ms)，值为 0 时，notify 不会消失
    duration: {
        type: Number,
        default: 3000
    },
    title: String,
    content: String
},
  emits: ['update:show'],
  setup(__props, { emit }) {

const props = __props;




const transitionName = computed(() => props.show ? 'notify-in' : 'notify-out')

const onClose = () => {
    emit('update:show', false)
}

watch(() => props.show, (isShow) => {
    if (isShow && props.duration) {
        window.setTimeout(() => {
            onClose()
        }, props.duration)
    }
})

return (_ctx: any,_cache: any) => {
  const _component_app_statusbar = _resolveComponent("app-statusbar")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: transitionName.value }, {
      default: _withCtx(() => [
        (__props.show)
          ? (_openBlock(), _createBlock(_component_app_statusbar, {
              key: 0,
              class: "app-notify"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: "app-notify__container",
                  onClick: onClose
                }, [
                  _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("h4", null, [
                      _renderSlot(_ctx.$slots, "title", {}, () => [
                        _createTextVNode(_toDisplayString(__props.title), 1)
                      ])
                    ]),
                    _createElementVNode("p", null, [
                      _renderSlot(_ctx.$slots, "default", {}, () => [
                        _createTextVNode(_toDisplayString(__props.content), 1)
                      ])
                    ])
                  ])
                ])
              ]),
              _: 3
            }))
          : _createCommentVNode("", true)
      ]),
      _: 3
    }, 8, ["name"])
  ]))
}
}

})